<template>
  <div class="avue-sidebar" :style="'height:100%;background-color: #20222a;width:'+(isCollapse?'65px;':'201px;')">
    <!-- logo -->
    <div class="logo">
      <img src="../../../public/img/logo1.png" />
      <div class="title" v-if="!isCollapse">数据系统</div>
    </div>
    <!-- 左侧菜单 -->
    <el-menu
      unique-opened
      :default-active="active"
      class="el-menu-vertical-demo"
      background-color="#20222a"
      text-color="#fff"
      :collapse="isCollapse"
      style="height: calc(100% - 60px);overflow: auto;"
      active-text-color="#ffd04b">			
      <router-link to="/home/index">
        <el-submenu index="home">
        <template slot="title">
          <img  src="../../../public/img/home@2x.png" style="width: 20px;height: 20px;"/>
          <span slot="title">数据看板</span>
        </template>
        <el-menu-item-group>
          <router-link to="/home/index">
            <el-menu-item index="/home/index"><i class="el-icon-s-data"></i>平台首页</el-menu-item>
          </router-link>
					<router-link to="/home/api-apply">
					  <el-menu-item index="/home/api-apply"><i class="el-icon-s-platform"></i>接口申请</el-menu-item>
					</router-link>
        </el-menu-item-group>
      </el-submenu>
      </router-link>

      <!-- <el-submenu index="user">
        <template slot="title">
          <img  src="../../../public/img/dingdan@2x.png" style="width: 20px;height: 20px;"/>
          <span slot="title">商户管理</span>
        </template>
        <el-menu-item-group>
          <router-link to="/user/user_manage">
            <el-menu-item index="/user/user_manage"><i class="el-icon-s-goods"></i>商户列表</el-menu-item>
          </router-link>
          <router-link to="/user/fund">
            <el-menu-item index="/user/fund"><i class="el-icon-orange"></i>待审核</el-menu-item>
          </router-link>
          <router-link to="/user/thoroughfare">
            <el-menu-item index="/user/thoroughfare"><i class="el-icon-film"></i>通道管理</el-menu-item>
          </router-link>
          <router-link to="/user/index">
            <el-menu-item index="/user/index"><i class="el-icon-cpu"></i>余量预警</el-menu-item>
          </router-link>
        </el-menu-item-group>
      </el-submenu> -->
      <el-submenu index="business">
        <template slot="title">
          <img  src="../../../public/img/shangpin@2x.png" style="width: 20px;height: 20px;"/>
          <span slot="title">接口管理</span>
        </template>
        <el-menu-item-group>
          <router-link to="/api-manage/api-desc">
            <el-menu-item index="/api-manage/api-desc"><i class="el-icon-film"></i>接口介绍</el-menu-item>
          </router-link>
          <router-link to="/api-manage/api-doc">
            <el-menu-item index="/api-manage/api-doc"><i class="el-icon-cpu"></i>接口文档</el-menu-item>
          </router-link>
          <!-- <router-link to="/api-manage/api-apply">
            <el-menu-item index="/api-manage/api-apply"><i class="el-icon-s-platform"></i>待审核通道</el-menu-item>
          </router-link> -->
        </el-menu-item-group>
      </el-submenu>
      <!-- <el-submenu index="product">
        <template slot="title">
          <img  src="../../../public/img/cesuan@2x.png" style="width: 20px;height: 20px;"/>
          <span slot="title">数据管理</span>
        </template>
        <el-menu-item-group>
          <router-link to="/product/index">
            <el-menu-item index="/product/index"><i class="el-icon-menu"></i>数据分类</el-menu-item>
          </router-link>
          <router-link to="/product/template">
              <el-menu-item index="/product/template"><i class="el-icon-lollipop"></i>数据模板</el-menu-item>
            </router-link>
          <router-link to="/product/caozuo">
            <el-menu-item index="/product/caozuo"><i class="el-icon-c-scale-to-original"></i>数据操作</el-menu-item>
          </router-link>
        </el-menu-item-group>
      </el-submenu> -->
      <!-- <el-submenu index="test">
        <template slot="title">
          <img  src="../../../public/img/yuangong@2x.png" style="width: 20px;height: 20px;"/>
          <span slot="title">爬虫设置</span>
        </template>
        <el-menu-item-group>
          <router-link to="/test/index">
            <el-menu-item index="/test/index"><i class="el-icon-s-platform"></i>IP黑名单</el-menu-item>
          </router-link>
          <router-link to="/test/access">
            <el-menu-item index="/test/access"><i class="el-icon-s-operation"></i>单IP访问评率</el-menu-item>
          </router-link>
        </el-menu-item-group>
      </el-submenu> -->
      <!-- <el-submenu index="setweb">
        <template slot="title">
          <img  src="../../../public/img/kehu@2x.png" style="width: 20px;height: 20px;"/>
          <span slot="title">前端设置</span>
        </template>
        <el-menu-item-group>
          <router-link to="/setweb/index">
            <el-menu-item index="/setweb/index"><i class="el-icon-s-marketing"></i>轮播图</el-menu-item>
          </router-link>
          <router-link to="/setweb/announcement">
            <el-menu-item index="/setweb/announcement"><i class="el-icon-s-help"></i>平台公告</el-menu-item>
          </router-link>
          <router-link to="/setweb/apply">
            <el-menu-item index="/setweb/apply"><i class="el-icon-s-marketing"></i>申请页面</el-menu-item>
          </router-link>
        </el-menu-item-group>
      </el-submenu> -->
      <!-- <el-submenu index="system">
          <template slot="title">
            <img  src="../../../public/img/xitong@2x.png" style="width: 20px;height: 20px;"/>
            <span slot="title">系统安全</span>
          </template>
            <el-menu-item-group>
            <router-link to="/system/logdata">
              <el-menu-item index="/system/logdata"><i class="el-icon-s-claim"></i>日志列表</el-menu-item>
            </router-link>
            <router-link to="/system/monitor">
              <el-menu-item index="/system/monitor"><i class="el-icon-sunrise-1"></i>系统监控</el-menu-item>
            </router-link>
            </el-menu-item-group>
      </el-submenu> -->
    </el-menu>
  </div>
</template>

<script>
  export default {
    name: 'sidebarItem',
    data() {
      return {
        isCollapse: false,
        active: '/home/index'
      };
    },
    created() {
    },
    mounted() {
      let that = this;
      setInterval(function() { // 定位当前菜单
        that.active = that.$router.currentRoute.path;
      },
      500);
    },
    computed: {
      nowTagValue() {
        return this.$router.path;
      }
    },
    methods: {
      changeCollapse(){
        this.isCollapse = !this.isCollapse;
        this.$emit('changeCollapse');
      },
      vaildActive(path) {
        // if (this.validIsOpen(item)) {
        //   return false;
        // }
        return this.nowTagValue === path;
      }
    }
  };
</script>

<style>
  .el-menu{
    border-right: none!important;
  }
  .is-active{

  }
  .avue-sidebar{
    padding-top: 0!important;
  }
</style>



// WEBPACK FOOTER //
// src/page/left/index.vue